export default function useAnalyticsAttributes(tileVehicleId: number) {
  return JSON.stringify({ tileVehicleId });
}
